import { render, staticRenderFns } from "./CXClientSettings.vue?vue&type=template&id=a2b6f368&scoped=true&"
import script from "./CXClientSettings.vue?vue&type=script&lang=js&"
export * from "./CXClientSettings.vue?vue&type=script&lang=js&"
import style0 from "./CXClientSettings.vue?vue&type=style&index=0&id=a2b6f368&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b6f368",
  null
  
)

export default component.exports